export const  tableColumnData = [
  { label: "流程编号", prop: "appliCode", align: "center", width: 180, type: "CUSTOM", fixed: "left" },
  { label: "流程类型", prop: "approveType", align: "center" },
  { label: "流程标题", prop: "title", align: "center" },
  { label: "流程日期", prop: "appliTime", align: "center", type: 'DATETIME' },
  // { label: "申请人", prop: "user", align: "center" },
  { label: "一级部门", prop: "deptName", align: "center" },
  { label: "流程状态", prop: "statusStr", align: "center", type: "CUSTOM", width: 100 },
  {
    label: "操作",
    prop: "operation",
    type: "CUSTOM",
    align: "center",
    fixed: "right",
    width: 100,
  },
]